<template>
  <div class="content-panel">
    <div class="panel-title-wrap">
      <h3 class="panel-title">{{ $t("verifyPanel.title") }}</h3>
      <span class="panel-sub">{{ $t("verifyPanel.subtitle") }}</span>
    </div>
    <div class="verify-list">
      <div class="verify-item" :class="{ verified: profile.is_auth == 2 }">
        <div class="verify-info">
          <span class="verify-icon">🪪</span>
          <div>
            <div class="verify-label">{{ $t("verifyPanel.realName") }}</div>
            <div class="verify-desc">
              {{ $t("verifyPanel.realNameDesc") }}
            </div>
          </div>
        </div>
        <span
          class="verify-status"
          :class="profile.is_auth == 2 ? 'status-verified' : 'status-pending'"
        >
          {{ profile.is_auth == 2 ? $t("verifyPanel.verified") : $t("verifyPanel.goVerify") }}
        </span>
      </div>
      <!-- <div class="verify-item" :class="{ verified: verify.face }">
        <div class="verify-info">
          <span class="verify-icon">😊</span>
          <div>
            <div class="verify-label">人脸认证</div>
            <div class="verify-desc">
              {{ verify.face ? "已认证" : "未认证，请进行人脸识别" }}
            </div>
          </div>
        </div>
        <span
          class="verify-status"
          :class="verify.face ? 'status-verified' : 'status-pending'"
        >
          {{ verify.face ? "已认证 ✓" : "去认证 →" }}
        </span>
      </div>
      <div class="verify-item" :class="{ verified: verify.google }">
        <div class="verify-info">
          <span class="verify-icon">🔑</span>
          <div>
            <div class="verify-label">Google Authenticator</div>
            <div class="verify-desc">
              {{ verify.google ? "已绑定" : "未绑定，建议开启二次验证" }}
            </div>
          </div>
        </div>
        <span
          class="verify-status"
          :class="verify.google ? 'status-verified' : 'status-pending'"
        >
          {{ verify.google ? "已绑定 ✓" : "去绑定 →" }}
        </span>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "VerifyPanel",
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
.content-panel {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.panel-title-wrap {
  margin-bottom: 28px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 4px 0;
}

.panel-sub {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.35);
}

/* ===== 账号认证 ===== */
.verify-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.verify-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 18px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.04);
  transition: all 0.3s ease;
}

.verify-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.verify-item.verified {
  border-color: rgba(0, 201, 81, 0.15);
}

.verify-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.verify-icon {
  font-size: 22px;
}

.verify-label {
  font-size: 15px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
}

.verify-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.35);
  margin-top: 2px;
}

.verify-status {
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 14px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.status-verified {
  color: #00c951;
  background: rgba(0, 201, 81, 0.08);
}

.status-pending {
  color: #ffd866;
  background: rgba(255, 216, 102, 0.08);
}

.status-pending:hover {
  background: rgba(255, 216, 102, 0.15);
}

/* ===== 响应式 ===== */
@media (max-width: 480px) {
  .panel-title {
    font-size: 17px;
  }
  .verify-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>
